import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import  getBaseUrl from "../getBaseUrl";
import { showSnackbar } from "./snackbar";
import { getApiErrorMessage } from "../../utils/apiError";
import { BASE_URL, getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import secureLocalStorage from "react-secure-storage";
const baseUrl = getBaseUrl();
// Thunks for API calls
export const newChatSessionId = createAsyncThunk(
  "newChatSession",
  async (mail, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/user_session`,
        {
          metadata: {},
        },
        {
          headers: {
            "Content-Type": "application/json",
            "use-case": "src",
            ...getAuthApiHeaders({ includeIncomingEmail: true }),
          },
          withCredentials: true,
        },
      );
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Failed to load!", severity: "error" }));
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
);
export const checkUserSessionId = createAsyncThunk(
  "checkUserSessionId",
  async (param, { rejectWithValue, dispatch }) => {
    // Access the result of the first API call from the state
    try {
      const response = await axios.post(
        `${baseUrl}/user_session/${param.sessionId}/chat`,
        param.payload,
        {
          headers: {
            "Content-Type": "application/json",
            "use-case": "src",
            ...getAuthApiHeaders({ includeIncomingEmail: true }),
          },
          withCredentials: true,
        },
      );
      // dispatch(getUserSessions(param.userEmail))
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Failed to load!", severity: "error" }));
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
);

// Create slice
const createNewSessionSlice = createSlice({
  name: "create-new-session-slice",
  initialState: {
    data: null,
    loading: false,
    isError: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Handle fetchData1
    builder
      // Handle fetchDataFromApi1
      .addCase(newChatSessionId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(newChatSessionId.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(newChatSessionId.rejected, (state, action) => {
        state.loading = false;
        state.isError = true;
        state.error = action.payload;
      })
      // Handle fetchDataFromApi2
      .addCase(checkUserSessionId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkUserSessionId.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(checkUserSessionId.rejected, (state, action) => {
        state.loading = false;
        state.isError = true;
        state.error = action.payload;
      });
  },
});

export default createNewSessionSlice.reducer;
